import { __assign, __read, __spreadArray } from "tslib";
import { KeyGenerator } from '@tencent/memoire-core';
import { NoTableInfoError } from '../error/errors';
var TABLE_KEY = Symbol.for('TABLE_KEY');
var TableOperationUtils = /** @class */ (function () {
    function TableOperationUtils() {
    }
    TableOperationUtils.saveTableInfo = function (tableInfo, target) {
        Object.defineProperty(target, TABLE_KEY, {
            configurable: true,
            value: __assign({}, tableInfo),
        });
    };
    TableOperationUtils.getTableInfo = function (target) {
        return target[TABLE_KEY];
    };
    /**
     * Find the first tableInfo along the prototype chain, stop and return if found
     * @param target
     * @returns
     */
    TableOperationUtils.getFirstTableInfoAlongPrototypeChain = function (target) {
        var tableInfo = this.getTableInfo(target);
        var cloneInfo = Object.assign({}, tableInfo);
        cloneInfo.properties = new Map(cloneInfo.properties);
        return cloneInfo;
    };
    TableOperationUtils.getTableName = function (modelClass) {
        var tableInfo = this.getTableInfo(modelClass.prototype);
        if (!(tableInfo === null || tableInfo === void 0 ? void 0 : tableInfo.tableName)) {
            throw new NoTableInfoError(modelClass.name);
        }
        return tableInfo.tableName;
    };
    TableOperationUtils.addTablePropertyInfo = function (target, property) {
        var tableInfo = TableOperationUtils.getOrCreateTableInfo(target);
        if (tableInfo.properties.has(property.name)) {
            var oldProperty = tableInfo.properties.get(property.name);
            Object.assign(property, oldProperty);
        }
        tableInfo.properties.set(property.name, property);
        this.saveTableInfo(tableInfo, target);
    };
    TableOperationUtils.createPropertyInfo = function (propertyName, alias) {
        return { name: propertyName, alias: alias, isUnionKey: false };
    };
    TableOperationUtils.convertTableInfoToSchema = function (tableInfo) {
        if (!tableInfo.tableName)
            return null;
        var properties = __spreadArray([], __read(tableInfo.properties.values()));
        var indices = properties
            .filter(function (property) {
            return property.isIndex;
        })
            .map(function (property) {
            var _a, _b;
            return {
                name: (_a = property.alias) !== null && _a !== void 0 ? _a : property.name,
                path: (_b = property.alias) !== null && _b !== void 0 ? _b : property.name,
                unique: property.isUnique,
            };
        });
        var key;
        if (!tableInfo.autoIncrement && tableInfo.keyPath) {
            key = { path: tableInfo.keyPath.length === 1 ? tableInfo.keyPath[0] : tableInfo.keyPath };
        }
        else {
            key = { generator: KeyGenerator.AutoIncrement };
        }
        return {
            properties: properties.map(function (prop) { var _a; return (_a = prop.alias) !== null && _a !== void 0 ? _a : prop.name; }),
            indices: indices,
            key: key,
            name: tableInfo.tableName,
        };
    };
    TableOperationUtils.createDefaultTableInfo = function () {
        return { tableName: null, autoIncrement: true, properties: new Map() };
    };
    TableOperationUtils.getOrCreateTableInfo = function (target) {
        if (Object.prototype.hasOwnProperty.call(target, TABLE_KEY)) {
            return target[TABLE_KEY];
        }
        // create new tableInfo;
        var tableInfo = TableOperationUtils.createDefaultTableInfo();
        // get tableInfo from prototype chain, and merge it;
        var parentTableInfo = target[TABLE_KEY];
        if (parentTableInfo) {
            tableInfo.properties = new Map(__spreadArray(__spreadArray([], __read(parentTableInfo.properties)), __read(tableInfo.properties)));
        }
        TableOperationUtils.saveTableInfo(tableInfo, target);
        return tableInfo;
    };
    return TableOperationUtils;
}());
export default TableOperationUtils;
//# sourceMappingURL=table-operation-utils.js.map